import CreateVideoContainer from "../containers/CreateVideoContainer";

const CreateVideoPage = () => {
  return (
    <CreateVideoContainer />
  );
};

export default CreateVideoPage;
